import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceFactory } from '../../../../device-factory/device-factory';

@Component({
	selector: 'app-charger-utilization-score',
	templateUrl: './charger-utilization-score.component.html',
	styleUrls: ['./charger-utilization-score.component.css']
})
export class ChargerUtilizationScoreComponent implements OnChanges {
	@Input() devices: any = {};
	@Input() utilizationScoreData: any = {};
	@Input() chargerAhScore: any = {};
	@Input() chargerKwhScore: any = {};
	@Input() selectedPeriod: string = '';

	@Input() userParentFilters: boolean = false;

	chargerDeviceType = DeviceFactory.types.charglink;
	utilizationScoreSelectedData = [];
	chargerAhScoreSelectedData = [];
	chargerKwhScoreSelectedData = [];

	periods = [
		{ value: 'last_7_days', label: this.translate.instant('durations.last_7_days') },
		{ value: 'last_14_days', label: this.translate.instant('durations.last_14_days') },
		{ value: 'last_30_days', label: this.translate.instant('durations.last_30_days') },
		{ value: 'last_90_days', label: this.translate.instant('durations.last_90_days') },
		{ value: 'year_to_date', label: this.translate.instant('durations.year_to_date') },
		{ value: 'last_year', label: this.translate.instant('durations.last_year') },
		{ value: 'since_installation', label: this.translate.instant('durations.all_years') },
	];

	daysFilters = [
		{ value: 'allDays', label: this.translate.instant('g.all_days') },
		{ value: 'workingDays', label: this.translate.instant('g.workings_days') },
	];

	selectedDaysFilter = this.daysFilters[0].value;

	constructor(private translate: TranslateService, private cdr: ChangeDetectorRef) { }

	ngOnInit() {
		this.updateSelectedData();
	}

	ngOnChanges() {
		this.updateSelectedData();
	}

	onSelectionChanged(event) {
		switch (event.filter) {
			case 'period':
				this.selectedPeriod = event.value;
				break;
			case 'daysFilter':
				this.selectedDaysFilter = event.value;
				break;
			default:
				break;
		}

		this.updateSelectedData();
	}

	updateSelectedData() {
		this.utilizationScoreSelectedData = this.utilizationScoreData || {};
		this.chargerAhScoreSelectedData = this.chargerAhScore || {};
		this.chargerKwhScoreSelectedData = this.chargerKwhScore || {};
		this.cdr.markForCheck();
	}
}
